import { FC, useMemo } from 'react';
import { Select } from 'antd';
import { FormAnswerRestriction } from '../../models/TaskForm/TaskForm';
import styles from './templateEditorModal.module.css';

export interface AnswerRestrictionOption {
  value: FormAnswerRestriction;
  label: string;
}

interface Props {
  value: FormAnswerRestriction;
  onChange: (value: FormAnswerRestriction) => void;
  disabled?: boolean;
  options?: AnswerRestrictionOption[];
  fallbackOptions?: AnswerRestrictionOption[];
  dataTestId?: string;
}

export const AnswerRestrictionSelect: FC<Props> = ({
  value,
  onChange,
  disabled,
  options,
  fallbackOptions = [],
  dataTestId,
}) => {
  const selectOptions = useMemo(() => {
    const sourceOptions = options?.length ? options : fallbackOptions;
    const seen = new Set<FormAnswerRestriction>();

    return sourceOptions.filter((option) => {
      if (seen.has(option.value)) {
        return false;
      }

      seen.add(option.value);
      return true;
    });
  }, [fallbackOptions, options]);

  return (
    <Select
      className={styles.answerRestrictionSelect}
      value={value}
      options={selectOptions}
      disabled={disabled}
      onChange={onChange}
      data-testid={dataTestId}
    />
  );
};

AnswerRestrictionSelect.displayName = 'AnswerRestrictionSelect';
